<template>
    <div>
        <breadcrumb
            class="inline-block"
            :links="[
                {
                    text: saleCatgSlctDesp,
                    route: productGroupRoute(saleCatgSlctCode)
                },
                ...(prodCatgDesp ? [{ text: prodCatgDesp }] : [])
            ]"
        />
        <button
            v-if="showProdCatgFltr === 'Y'"
            class="ml-4 bg-secondary rounded p-1 pr-2"
            @click="showProdCatgSlctMenu = true"
        >
            <div class="text-white">
                <div
                    class="inline-block align-bottom fill-current leading-none"
                >
                    <menuSvg />
                </div>
                <span class="text-white">分類</span>
            </div>
        </button>
        <section class="my-4">
            <BannerAdvertisement
                class="mt-2"
                type="inPage"
                ref="BannerAdvertisement"
                :fillImgHeight="true"
            />
            <ProductList :list="productListByProdCatg" />
        </section>
        <div class="flex justify-end">
            <button
                class="text-secondary flex justify-end focus:outline-none"
                @click="scrollToTop"
            >
                <!-- <div>
                    &uarr;
                </div> -->
                <div class="icon">
                    <keyboardArrowUpSvg />
                </div>
                <div class="text-lg mr-3">
                    {{ $t('common.scroll.to.top') }}
                </div>
            </button>
        </div>

        <floatingProdCatgSlctMenu
            :showMenu="showProdCatgSlctMenu"
            :prodList="productListBySaleCatgSlctCode"
            @close="showProdCatgSlctMenu = false"
            @setProdCatgSlctKey="setProdCatgSlctKey"
        />
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import ProductList from '../../components/productList.vue';
import BannerAdvertisement from '../../components/bannerAdvertisement.vue';
import keyboardArrowUpSvg from '../../assets/svg/keyboard_arrow_up.svg';
import floatingProdCatgSlctMenu from '../../components/floatingProductCategorySelectionMenu.vue';
import menuSvg from '@/assets/svg/menu.svg';

export default {
    components: {
        breadcrumb,
        ProductList,
        BannerAdvertisement,
        keyboardArrowUpSvg,
        floatingProdCatgSlctMenu,
        menuSvg
    },
    data() {
        return {
            saleCatgSlctCode: this.$route.params.saleCatgSlctCode,
            showProdCatgSlctMenu: false,
            prodCatgSlctKey: parseInt(this.$route.params.prodCatgSlctKey)
        };
    },
    watch: {
        '$route.params.saleCatgSlctCode': {
            handler: function(to) {
                this.$data.saleCatgSlctCode = to;
                this.$refs['BannerAdvertisement'].shuffle();
                this.showProdCatgSlctMenu = false;
            }
        },
        '$route.params.prodCatgSlctKey': {
            handler: function(to) {
                this.$data.prodCatgSlctKey = parseInt(to);
                this.showProdCatgSlctMenu = false;
            }
        }
    },
    computed: {
        productListBySaleCatgSlctCode() {
            return this.$store.getters
                .productListBySaleCatgSlctCode(this.saleCatgSlctCode)
                .filter(product => product.dispProdInd === 'Y');
        },
        productListByProdCatg() {
            if (this.prodCatgSlctKey) {
                return this.productListBySaleCatgSlctCode.filter(
                    product => product.prodCatgSlctKey === this.prodCatgSlctKey
                );
            } else if (this.prodCatgSlctKey === 0) {
                return this.productListBySaleCatgSlctCode.filter(
                    product =>
                        product.prodCatgSlctKey === null ||
                        product.prodCatgSlctKey === undefined
                );
            } else {
                return this.productListBySaleCatgSlctCode;
            }
        },
        productListSaleCatgList() {
            return this.$store.getters.productListSaleCatgList || [];
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        saleCatgSlctDesp() {
            return this.productListSaleCatgList.find(
                c => c.saleCatgSlctCode === this.saleCatgSlctCode
            )?.saleCatgSlctDesp;
        },
        showProdCatgFltr() {
            return this.$store.state.showProdCatgFltr;
        },
        prodCatgList() {
            return this.$store.state.prodCatgList || [];
        },
        prodCatgDesp() {
            const prodCatg = this.prodCatgList.filter(
                prodCatg => prodCatg.id === this.prodCatgSlctKey
            );
            return prodCatg.length <= 0
                ? this.prodCatgSlctKey === 0
                    ? '其他'
                    : undefined
                : prodCatg[0].slctDesp;
        },
        productGroupRoute() {
            return (saleCatgSlctCode, prodCatgSlctKey) =>
                this.$store.getters.productGroupRoute(
                    saleCatgSlctCode,
                    prodCatgSlctKey
                );
        }
    },
    mounted() {
        if (this.$store.getters.productList.length === 0) {
            this.$router.push({ name: 'beyondSalesPeriod' });
        } else if (this.productListBySaleCatgSlctCode.length === 0) {
            this.$router.push('/');
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        setProdCatgSlctKey(prodCatgSlctKey) {
            this.showProdCatgSlctMenu = false;
            if (prodCatgSlctKey !== null && prodCatgSlctKey !== undefined) {
                this.$router.push(
                    this.productGroupRoute(
                        this.saleCatgSlctCode,
                        prodCatgSlctKey
                    )
                );
                this.showProdCatgSlctMenu = false;
            } else {
                this.$router.push(
                    this.productGroupRoute(this.saleCatgSlctCode)
                );
            }
        }
    }
};
</script>
